"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRequest = void 0;
const tslib_1 = require("tslib");
const lib_1 = require("./lib");
const request_1 = require("./lib/core/request");
const enhance_1 = require("./enhance");
tslib_1.__exportStar(require("./lib"), exports);
function createRequest(factory, handlerError) {
    (0, request_1.setRequestFactory)(factory);
    return {
        infra: (0, enhance_1.enhance)(lib_1.InfraService, handlerError),
        editor: (0, enhance_1.enhance)(lib_1.EditorService, handlerError),
        ai: (0, enhance_1.enhance)(lib_1.AiService, handlerError),
        integration: (0, enhance_1.enhance)(lib_1.IntegrationService, handlerError),
        awsMarketplace: (0, enhance_1.enhance)(lib_1.AwsMarketplaceService, handlerError),
    };
}
exports.createRequest = createRequest;
